module.exports = __webpack_public_path__ + "static/media/kv-zh-Hant.2c429106.png";